<button
	type="button"
	role="checkbox"
	class="form-control lu-toggle__btn"
	[disabled]="disabled"
	[formlyAttributes]="field"
	[attr.aria-invalid]="showError"
	[attr.aria-checked]="toggleValue"
	[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
	[attr.aria-disabled]="disabled"
	[ngClass]="{
		'lu-toggle__btn--enabled': toggleValue,
		'lu-toggle__btn--disabled': disabled,
		'is-invalid': showError
	}"
	(click)="toggle()">
	<lu-icon icon="lu-completed" *ngIf="toggleValue && !icon && toggleLabel" class="lu-toggle__state"></lu-icon>

	<lu-icon *ngIf="icon" [icon]="icon" [ngClass]="{ 'lu-toggle__icon': toggleLabel }"></lu-icon>{{ toggleLabel }}
</button>
